import React, { useEffect, useRef, useState,useContext } from "react";
import "./MobileBottomBar.css";
import { useTranslation } from "react-i18next";
import { Icon, Nav, PrimaryButton } from "@fluentui/react";
// import { AuthRoutes } from "../../constants/navBarItemsConstants";
import HandBurgerIcon from "./nav-icons/Handburger";
import LeftArrowIcon from "./nav-icons/LeftArrowIcon";
import ArrowDownIcon from "./nav-icons/ArrowDownIcon";
import ArrowUpIcon from "./nav-icons/ArrowUpIcon";
import userContext from "../../context/users/UserContext";
import DeeptekLogo from "../SVGComponents/Logo/DeeptekLogo";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import { navBarItems } from "./helper/initialData";
import RowBadge from "../../pages/StudyList/components/Badge/RowBadge";
import DownArrow from "../SVGComponents/DownArrow";
import { USERTYPES } from "../../constants/Constants";
import HeaderDropdown from "./HeaderDropdown/HeaderDropdown";
import { mobileNavBarItems } from "./helper/mobileInitialData";

const MobileBottomBar = (props) => {
  const { roles, authenticated, loadByUsername, userId, name } = useContext(userContext);
  const [showNavBar, setShowNavBar] = useState(false);
  const [showHeaderOption, setShowHeaderOptions] = useState(false);
  const [studyViewer,setStudyViewer] = useState(false);
  const [windowTemp, setWindow] = useState(true);
  const [list,setList] = useState();
  const [windowComplete, setWindowComplete] = useState(true);
  const [currentPath, setCurrentPath] = useState("");
  const [dropdown, setDropdown] = useState(false);
  const [delayHandler, setDelayHandler] = useState(null);
  const [closeNavbarButton, setCloseNavbarButton] = useState(false);
  const [t, i18n] = useTranslation();
  const navRef = useRef();
  useEffect(() => {
    if (!authenticated || roles.length == 0 || name.length == 0) {
      loadByUsername();
    }
    setShowNavBar(authenticated && isMobile);
  }, [authenticated,roles,name]);

  useEffect(() => {
      
      if(
        window.location.pathname.length == 0  ||
        window.location.pathname.length == 1  ||
        window.location.pathname.includes("/login") || 
      window.location.pathname.includes("report") || 
      window.location.pathname.includes("patient") ||
      window.location.pathname.includes("study/load") ||
      window.location.pathname.includes("shared/study")){
        setStudyViewer(false);
      }else{
        setStudyViewer(true);
      }
      setCurrentPath(window.location.pathname);
  },[window.location.pathname]);


  let listTemp = mobileNavBarItems(currentPath,roles,null);

  useEffect(()=>{
    if (!authenticated || roles.length == 0) {
      loadByUsername();
    }
    // console.log(listTemp);

    let temp = listTemp.filter((ele)=>ele.mobileBottomBar == true)
    let filterShow = temp.filter((ele,ind)=>{
      if(ele.show == true && ele?.mobileBottomBar == true)return ele;
    })
    // console.log(filterShow);
    setList(temp);
  },[currentPath,authenticated])




  const getRoleName = (role) => {
      if(role == USERTYPES.FIRMADMIN){
        return "FIRM ADMIN";
      }else if(role == USERTYPES.FIRMDOCTOR){
        return "FIRM DOCTOR";
      }else if(role == USERTYPES.FIRMTECHNICIAN){
        return "FIRM TECHNICIAN";
      }else{
        return role;
      }
  }


  return (
    showNavBar?
    <>
    {studyViewer?<>
      <div className="navbar-container-mobile" style={{width:'100%'}}>
     <nav className="navbar-menu-mobile modal-scroll"  
      >
      <ul className="navbar__list-mobile" style={{display:'flex',justifyContent:'space-around',alignItems:'center'}}>
        {list.length> 0 && list.map((item, i) => (
          item.show && item.path != "" && <div id={item.id}
           //onClick={(e)=> item.path==""?updateDropdown(item.id):null}
           style={{pointerEvents:item.path==""?'none':'',}}
           className={currentPath === item.path?"navbar__li-box-mobile active-tab-mobile ":"navbar__li-box-mobile"} key={i}>
            <a target={item.newTab!=undefined && item.newTab ? "_blank":""} href={item.path=="Not created yet"?"":item.path} className={item.path ==""?"link-mobile inactiveLink-mobile":"link-mobile"}>
            <div style={{display:'flex'}} className={`nav-icon ${
                                      currentPath === item.path
                                        ? "active-nav-icon"
                                        : ""
                                    }`}>
              { item.icon}
            </div>
            <li
              className="navbar__li-mobile"
              style={{ 
                margin:'0px',
                whiteSpace: 'nowrap'
              }}
            >
              {item.title}
            </li>
            
            </a>
          </div>
       
          
          
        ))}
      </ul>
    </nav>
    
    </div>
    
   
    {/* <div style={{width:'100%',height: "100%", overflowY: "auto"}}>
      <div className="navbar-header-style-mobile" style={{height: '8%'}}>
              <DeeptekLogo />
              <div className="navbar-avatar-section-mobile">
                <div style={{display:'flex',flex:'1'}}>
                <RowBadge name={getRoleName(roles[0])} />
                
                </div>
               
                <span className="navbar-user-name-mobile">
                  {name}
                  </span>
                <div style={{position:'relative'}}>
                  <div style={{position:'relative',cursor:'pointer'}} onClick={() => setShowHeaderOptions(true)}>
                    <DownArrow active={showHeaderOption}/>
                  </div>
                 <HeaderDropdown 
                 show={showHeaderOption}
                 onClickOutside={() => {
                   setShowHeaderOptions(false);
                 }}
                 /> 
                 
                </div>
              </div>
      </div>
      <div style={{height:"92%",width:"100%"}}>
      {props.children}
      </div>
      
      
      </div> */}
      </>:<>{props.children}</>}
    </>
    :
   <>{props.children}</>
  );
};

export default MobileBottomBar;
